import styled from 'styled-components';

import { HexColorBar } from '@dreryk/react-components';

import { PriceText } from '../../../../shared/PriceText';

export const StyledHexColorBar = styled(HexColorBar)`
   width: 8px;
   height: 18px;
`;

StyledHexColorBar.displayName = 'StyledHexColorBar';

export const StyledReceptionServicePriceText = styled(PriceText)`
   text-align: right;
   color: ${(props) => props.theme.placeholder};
`;

StyledReceptionServicePriceText.displayName = 'StyledReceptionServicePriceText';
